import { FormattedMessage } from 'react-intl'
import { ListBox, ListOption } from '@/ui/components'
import { strings } from './FontSelector.strings'
import { fontMap } from '@/ui/pages/PreviewPDF/createPdf/pdfFont'
import { CustomFont } from '@/ui/pages/PreviewPDF/createPdf/types'

const labelMap: Record<CustomFont, React.ReactElement> = {
  amaticSC: <FormattedMessage {...strings.amaticSC} />,
  domine: <FormattedMessage {...strings.domine} />,
  greatVibes: <FormattedMessage {...strings.greatVibes} />,
  lato: <FormattedMessage {...strings.lato} />,
  lobster: <FormattedMessage {...strings.lobster} />,
  montserrat: <FormattedMessage {...strings.montserrat} />,
  monument: <FormattedMessage {...strings.monument} />,
  openSans: <FormattedMessage {...strings.openSans} />,
  oswald: <FormattedMessage {...strings.oswald} />,
  playfairDisplay: <FormattedMessage {...strings.playfairDisplay} />,
  plusJakartaSans: <FormattedMessage {...strings.plusJakartaSans} />,
  poppins: <FormattedMessage {...strings.poppins} />,
  quicksand: <FormattedMessage {...strings.quicksand} />,
  raleway: <FormattedMessage {...strings.raleway} />,
  righteous: <FormattedMessage {...strings.righteous} />,
  roboto: <FormattedMessage {...strings.roboto} />,
  sacramento: <FormattedMessage {...strings.sacramento} />,
}

const fontOptions = Object.entries(fontMap).map(([key]) => ({
  id: key,
  label: labelMap[key as CustomFont],
  value: key,
}))

interface Props {
  onSelect: (selected: ListOption) => void
  initialValue: CustomFont
}

export const FontSelector: React.FC<Props> = (props) => {
  const initialValue = fontOptions.filter(
    (option) => (option.id as CustomFont) === props.initialValue,
  )[0]

  return (
    <ListBox
      label={<FormattedMessage {...strings.coverFont} />}
      options={fontOptions}
      onSelect={props.onSelect}
      initialValue={initialValue}
    />
  )
}
